import {makeStyles} from "@material-ui/core/styles"

export default makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    textAlign: "center",
    color: "#9F9F9F",
    backgroundColor: "",
    borderRadius: "15px 15px 0 0",
    padding: "1px",
    marginTop: "25px",
  },
  git: {
    color: "#2D93D3",
    textDecoration: "none",
    "&:hover": {
      color: "#00A0C6",
      cursor: "pointer",
    },
  },
  appBarSearch: {
    borderRadius: 4,
    marginBottom: "1rem",
    display: "flex",
    padding: "16px",
  },
  pagination: {
    borderRadius: 4,
    marginTop: "1rem",
    padding: "16px",
  },
  gridContainer: {
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column-reverse",
    },
  },
  searchButton: {
    color: "white",
    backgroundColor: "#2D93D3",
    marginBottom: 10,
    "&:hover": {
      backgroundColor: "#1e88ca",
    },
  },
}))
